import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Toolbar } from '@mui/material/'; // Adds a psudo margin of the hight of the navbar
import { Container } from '@mui/material';
import { useContext, useEffect } from 'react';
import { appContext } from '../Contexts/AppContext';

const NoMatch: React.FC = (): JSX.Element => {
  const navigate = useNavigate();
  const { companyId } = useParams();
  const [t] = useTranslation();
  const { company } = useContext(appContext);
  const location = useLocation();

  useEffect(() => {
    // handles when no company in url, eliminate 404 for no company in url
    if (!companyId && company) {
      // Cache the current location path
      const currentPath = location.pathname;
      // Check if the current location path already contains the company name/id
      const includesCompany = currentPath.includes("/"+company+"/")

      // If it does, refresh the page. If not, redirect to a new page with the company name/id as a prefix.
      const newPath = includesCompany
        ? currentPath
        : `/${company}${currentPath}`;

      navigate(newPath);
    }
  }, []);

  return (
    <Container
      className="App-header"
      data-testid="404-page-component"
      maxWidth={false}
    >
      <Toolbar />
      <h1>{t('HEADING_404_PAGE_NOT_FOUND')}</h1>
      <p>
        Return to <Link to={`/${company}`}>Home</Link>
      </p>
      <p>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            navigate(-1);
          }}
        >
          {t('BUTTON_BACK')}
        </Button>
      </p>
    </Container>
  );
};

export default NoMatch;
